<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-120-0 pb-300-100">
        <app-grey-card-with-title [title]="t('change.password')" [removeContentPaddingTop]="true">
          <div class="pt-16">
            <form #authFormEdit="ngForm" [formGroup]="inputForm">
              <app-input type="password" formControlName="password" label="app.common.password"/>
              <div class="pt-20-10">
                <app-input type="password" formControlName="confirmPassword" label="app.common.confirm.password"/>
              </div>
              <div class="pt-20-10 mt-30">
                <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                                [text]="t('app.common.submit')" [borderColor]="'var(--teal-500)'"
                                (onClickCallback)="onSubmit()" [isFullWidth]="true"></app-button-alt>
              </div>
              @if (changePasswordOnRecoveryComponentState ===
              changePasswordOnRecoveryComponentStateType.VERIFICATION_LINK_EXPIRED) {
                <div class="pt-4">
                  <p class="regular d-inline">{{ t('change.password.on.recovery.error.verification') }}</p>
                </div>
              }
              @if (changePasswordOnRecoveryComponentState ===
              changePasswordOnRecoveryComponentStateType.PASSWORDS_DO_NOT_MATCH) {
                <div class="pt-4">
                  <p class="regular d-inline">{{ t('change.password.on.recovery.error.password') }}</p>
                </div>
              }
            </form>
          </div>
        </app-grey-card-with-title>
      </div>
    </div>
  </app-page-template>
</ng-container>
